import { styled, useResponsive } from '@rabex-kit/rabex-ui';
import { SnackbarProvider } from 'notistack';
import { ReactNode } from 'react';
import { SnackbarUtilsConfigurator } from '../../utils/snackbar';
import XCircle from '../../static/images/svg/alerts/XCircle.svg?react';
import Warning from '../../static/images/svg/alerts/Warning.svg?react';
import SuccessWarning from '../../static/images/svg/alerts/SuccessWarning.svg?react';
import InfoWarning from '../../static/images/svg/alerts/InfoWarning.svg?react';
import WarningCircle from '../../static/images/svg/alerts/WarningCircle.svg?react';

type Props = {
  children?: ReactNode;
};

export default function CustomSnackbarProvider({ children }: Props) {
  const { matches } = useResponsive();

  const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
    '&.SnackbarItem-variantSuccess': {
      backgroundColor: theme.palette.success[50]
    },
    '&.SnackbarItem-variantError': {
      backgroundColor: theme.palette.error[50]
    },
    '&.SnackbarItem-variantWarning': {
      backgroundColor: theme.palette.warning[50]
    },
    '&.SnackbarItem-variantInfo': {
      backgroundColor: theme.palette.info[50]
    }
  }));
  return (
    <StyledSnackbarProvider
      anchorOrigin={{
        vertical: matches({ xs: 'top', lg: 'top' }),
        horizontal: matches({ xs: 'center', lg: 'right' })
      }}
      autoHideDuration={3000}
      maxSnack={5}
      // hideIconVariant
      iconVariant={{
        success: <SuccessWarning />,
        error: <XCircle />,
        warning: <Warning />,
        info: <InfoWarning />,
        default: <WarningCircle />
      }}>
      <SnackbarUtilsConfigurator />
      {children}
    </StyledSnackbarProvider>
  );
}
